<template>
  <div>
    <Header></Header>

    <div class="confirmOrder">
      <div class="container-xl main">
        <div class="info">
          <div class="head">订单信息</div>
          <div class="info-main">
            <div class="info-details">
              2022执业药师《（中）药学专业知识（一）精讲课程
            </div>
            <div class="price-info"><span>￥</span>199</div>
          </div>

          <!-- <div>+添加地址</div> -->

          <div class="address-info">
            <div class="address-title">
              <div>地址信息</div>
              <div>+添加地址</div>
            </div>

            <!--  -->
            <div class="contact-card">
              <div class="contact-info">
                <div class="name">张思思</div>
                <div class="line"></div>
                <div class="phone">13516254965</div>
                <div class="address">
                  江苏省南京市鼓楼区铁路北街128号南京财经大学科技楼
                </div>
              </div>
              <div class="contact-actions">
                <div>
                  <i class="el-icon-edit"></i>
                  <span class="edit button">编辑</span>
                </div>
                <div>
                  <i class="el-icon-delete"></i>
                  <span class="delete-button">删除</span>
                </div>
              </div>
            </div>

            <!-- TODO  -->
            <!-- 省市区赋值
新旧简历 -->

            <!--  -->

            <div class="address-form">
              <el-dialog
                title="添加收货地址"
                :visible.sync="dialogVisible"
                width="40%"
                :before-close="handleClose"
              >
                <el-form
                  :model="form"
                  :rules="rules"
                  ref="addressForm"
                  label-width="80px"
                >
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="收件人" prop="receiver">
                        <el-input
                          v-model="form.receiver"
                          placeholder="请输入收件人姓名"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="phone">
                        <el-input
                          v-model="form.phone"
                          placeholder="请输入手机号码"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="省份">
                        <el-select
                          v-model="provinceValue"
                          placeholder="请选择省份"
                          @change="provinceChange"
                        >
                          <el-option
                            v-for="province in provinceAndCityData"
                            :key="province.value"
                            :label="province.label"
                            :value="province.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="8">
                      <el-form-item label="城市" prop="city">
                        <el-select
                          v-model="cityValue"
                          placeholder="请选择城市"
                          @change="cityChange"
                        >
                          <el-option
                            v-for="city in pcTextArr"
                            :key="city.value"
                            :label="city.label"
                            :value="city.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="8">
                      <el-form-item label="区县" prop="district">
                        <el-select v-model="areaValue" placeholder="请选择地区">
                          <el-option
                            v-for="area in codeToText"
                            :key="area.value"
                            :label="area.label"
                            :value="area.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- <el-col :span="8">
                      <el-form-item label="省份" prop="province">
                        <el-select
                          v-model="form.province"
                          placeholder="请选择省份"
                          @change="handleProvinceChange"
                        >
                          <el-option
                            v-for="item in provinces"
                            :key="item"
                            :label="item"
                            :value="item"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="城市" prop="city">
                        <el-select
                          v-model="form.city"
                          placeholder="请选择城市"
                          :disabled="!form.province"
                          @change="handleCityChange"
                        >
                          <el-option
                            v-for="item in cities"
                            :key="item"
                            :label="item"
                            :value="item"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="区县" prop="district">
                        <el-select
                          v-model="form.district"
                          placeholder="请选择区县"
                          :disabled="!form.city"
                        >
                          <el-option
                            v-for="item in districts"
                            :key="item"
                            :label="item"
                            :value="item"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col> -->
                  </el-row>

                  <el-form-item label="详细地址" prop="address">
                    <el-input
                      type="textarea"
                      v-model="form.address"
                      rows="3"
                      placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等"
                    >
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-checkbox v-model="form.isDefault"
                      >设为默认地址</el-checkbox
                    >
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="handleClose">取 消</el-button>
                  <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                  >
                </span>
              </el-dialog>
            </div>

            <!-- <div class="emptyOrder">
              <img src="@/assets/imgs/kaoguo/emptyOrder.png" alt="" />
              <div class="address-tip">暂无地址信息，<span>去添加</span></div>
            </div> -->
          </div>

          <div class="pay-panel">
            <div class="title">支付方式</div>
            <label class="active wix"
              ><div>
                <input name="pay" type="radio" value="wix" checked="" /><img
                  alt=""
                  src="//nodestatic.fbstatic.cn/weblts_spa_online/electronsw//assets/img/weixinzhifu.svg"
                />&nbsp;微信
              </div>
              <div class="price-block">
                <div><span>¥</span> <span>299</span></div>
              </div></label
            ><label class="ali"
              ><div>
                <input name="pay" type="radio" value="ali" /><img
                  alt=""
                  src="//nodestatic.fbstatic.cn/weblts_spa_online/electronsw//assets/img/zhifubao.svg"
                />&nbsp;支付宝
              </div>
              <div class="price-block">
                <div><span>¥</span> <span>299</span></div>
              </div></label
            >
            <div class="horizontal-line"></div>
            <div class="pay-button-block">
              <button>立即支付</button>
            </div>
          </div>
          <!-- == -->
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/common/Header";
import Footer from "@/common/Footer";

import {
  provinceAndCityData,
  pcTextArr,
  codeToText,
} from "element-china-area-data";
// import { regionData, CodeToText, TextToCode } from "element-china-area-data";
// import { provinceList, cityList, areaList } from "element-china-area-data";
export default {
  data() {
    return {
      dialogVisible: true,
      form: {
        receiver: "",
        phone: "",
        province: "",
        city: "",
        district: "",
        address: "",
        isDefault: false,
      },
      rules: {
        receiver: [
          { required: true, message: "请输入收件人姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        district: [
          { required: true, message: "请选择区县", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          {
            min: 5,
            max: 100,
            message: "长度在 5 到 100 个字符",
            trigger: "blur",
          },
        ],
      },
      provinceValue: "",
      cityValue: "",
      areaValue: "",
      provinceAndCityData: provinceAndCityData,
      pcTextArr: [],
      codeToText: [],
      provinces: [
        "北京市",
        "上海市",
        "天津市",
        "重庆市",
        "河北省",
        "山西省",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "江苏省",
      ],
      cities: [],
      districts: [],
    };
  },

  components: {
    Header,
    Footer,
  },

  methods: {
    provinceChange() {
      this.pcTextArr = [];
      this.codeToText = [];
      const selectedProvinceCode = this.provinceValue;
      // 根据省份代码筛选城市列表
      this.pcTextArr = pcTextArr.filter(
        (city) => city.provinceCode === selectedProvinceCode
      );
    },
    cityChange() {
      this.codeToText = [];
      const selectedCityCode = this.cityValue;
      // 根据城市代码筛选地区列表
      this.codeToText = codeToText.filter(
        (area) => area.cityCode === selectedCityCode
      );
    },
    handleProvinceChange() {
      this.form.city = "";
      this.form.district = "";
      this.cities = ["城市1", "城市2", "城市3", "城市4", "城市5"];
    },
    handleCityChange() {
      this.form.district = "";
      this.districts = ["区县1", "区县2", "区县3", "区县4", "区县5"];
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          console.log("submit form:", this.form);
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.confirmOrder {
  width: 100%;
  min-height: 700px;
  background: #f7f8fa;
  padding-top: 30px;
}
.info {
  padding: 30px;
  border-radius: 8px;

  //   box-shadow: 1px 0px 10px rgb(27 39 94 / 40%);
  background: #fff;
}
.head {
  color: #3c464f;
  font-size: 24px;
  margin-bottom: 18px;
  font-weight: 700;
}
.info-main {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: #3c464f;
  margin-bottom: 8px;
  font-weight: 700;
  border-bottom: 1px solid #e1e1e1;
  .price-info {
    color: #ff3d00;
    font-size: 40px;
    margin-bottom: -0.2rem;
    font-weight: 400;
    span {
      font-size: 24px;
    }
  }
}
.pay-panel {
  background-color: #fff;
  padding: 0 1.5rem;
  font-weight: 400;
  position: relative;
  .title {
    font-size: 18px;
    color: #3c464f;
    margin: 1.5rem 0;
    font-weight: 700;
  }
  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  label {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 1.5rem;
    font-size: 16px;
    color: #3c464f;
    line-height: 1.3;
    input {
      background-color: #f60;
      color: #f60;
      margin-right: 1.6rem;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      // outline: none;
      // display: none;
      width: 14px;
      height: 14px;
      line-height: 12px;
      border: 1px solid #eee;
      border-radius: 50%;
      margin-right: 15px;
      display: inline-block;
      background-color: #dfdfdf;
    }
    input[type="radio"]:checked {
      background-color: #0fce96;
    }
    .price-block {
      visibility: hidden;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      span {
        color: #b1b5b9;
      }

      div span {
        color: #ff3d00;
        font-size: 24px;
        font-weight: 400;
        font-family: Source Han Sans CN;
      }
      div span:first-of-type {
        font-size: 20px;
      }
    }
  }
  .pay-button-block {
    justify-content: center;
    text-align: right;
    button {
      width: 20rem;
      height: 4rem;
      max-width: 200px;
      max-height: 45px;
      background: #0fce96;
      border-radius: 4px;
      font-size: 16px;
      color: #fff;
      margin: 2rem 0;
      font-weight: 400;
      cursor: pointer;
    }
  }
}

.address-info {
  padding: 20px 0;
  border-bottom: 1px solid #e1e1e1;
  .address-title {
    display: flex;
    justify-content: space-between;

    div:nth-of-type(1) {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 50px;
    }
    div:nth-of-type(2) {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #0fce96;
      line-height: 50px;
    }
  }
  .emptyOrder {
    text-align: center;
    img {
      width: 343px;
      height: 236px;
    }
    .address-tip {
      margin-top: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      line-height: 50px;
      span {
        color: #0fce96;
      }
    }
  }
}
.pay-panel label.active .price-block {
  visibility: visible;
}
.active,
.ali:focus,
.wix:focus {
  background-color: #e6faf4;
}

button {
  border: none;
}
//
.contact-card {
  width: 354px;
  min-height: 198px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #0fce96;
  padding: 16px;
  font-size: 16px;
  color: #666666;
  .name {
    line-height: 50px;
    border-bottom: 1px solid #e1e1e1;
  }
  .phone {
    line-height: 50px;
  }
  .contact-actions {
    display: flex;
    font-size: 12px;
    margin-top: 20px;
  }
  .contact-actions > div {
    margin-right: 14px;
  }
}
</style>